<template>
  <div class="flex flex-col flex-wrap items-start">
    <div v-for="(cat, id) in sortedCategories" :key="id" class="w-full">
      <div v-if="cat.items" class="w-full mb-8">
        <SparkSelect
          v-model="cat.uid"
          :name="id"
          :label="cat.required ? cat.label + '*' : cat.label"
          :options="getSelectOptions(cat.items)"
          :error="shouldShowError(id, cat.uid, cat.required)"
          @click="handleSelectClick(id)"
          @update:model-value="saveComboCategory(id, cat)"
        />
      </div>

      <div v-if="!cat.items" class="w-full">
        <SparkInput
          v-model="cat.value"
          :name="id"
          :label="cat.required ? cat.label + '*' : cat.label"
          type="text"
          autocomplete="off"
          :error="shouldShowError(id, cat.value, cat.required)"
          @change="handleFieldInteraction(id); saveTextCategory(id, cat)"
          @blur="handleFieldInteraction(id)"
        />
      </div>
      <div v-if="validateThisUrl(cat.value)" title="Go to" class="external-link-icon" @click="goToUrl(cat.value)">
        <i class="fas fa-external-link-alt" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import SparkInput from '@/components/SparkComponents/SparkInput.vue';
import SparkSelect from '@/components/SparkComponents/SparkSelect.vue';
import validateUrl from '@/composables/validateUrl.js';

export default {
  name: 'PrpCategoryInput',

  components: {
    SparkInput,
    SparkSelect,
  },

  emits: ['close'],

  data() {
    return {
      touchedFields: new Set(),
    };
  },

  computed: {
    ...mapState('prp', ['prpOrderCategories']),
    ...mapState(['user', 'highlightCategories', 'partLibraryFilters']),
    ...mapState('application', ['axiosInstance']),

    sortedCategories() {
      const allCategories = {
        ...this.prpOrderCategories.prp_combo_categories,
        ...this.prpOrderCategories.prp_text_categories,
      };
      const entries = Object.entries(allCategories);
      entries.sort(([, a], [, b]) => {
        if (a['order_index'] < b['order_index']) {
          return -1;
        }
        if (a['order_index'] > b['order_index']) {
          return 1;
        }
        return 0;
      });

      const sortedObj = Object.fromEntries(entries);
      return sortedObj;
    },
  },

  methods: {
    ...mapActions('prp', ['fetchPrpOrderData']),

    getSelectOptions(items) {
      return Object.entries(items).map(([value, label]) => ({
        value,
        label,
      }));
    },

    validateThisUrl(url) {
      return validateUrl(url).validateBool;
    },

    goToUrl(url) {
      let prefix = 'https://';
      if (!url.includes(prefix) && !url.includes('http://')) {
        url = prefix + url;
      }
      window.open(url, '_blank');
    },

    handleFieldInteraction(fieldId) {
      this.touchedFields.add(fieldId);
    },

    handleSelectClick(fieldId) {
      this.touchedFields.add(fieldId);
    },

    shouldShowError(fieldId, value, isRequired) {
      return this.touchedFields.has(fieldId) && !value && isRequired ? 'This field is required' : '';
    },

    saveTextCategory(id, textcat) {
      let cat = {};
      cat[id] = {
        value: textcat.value,
      };
      this.updatePartNewPart({ prp_text_categories: cat });
    },

    saveComboCategory(id, combocat) {
      let cat = {};
      if (combocat.uid != '') {
        cat[id] = {
          uid: combocat.uid,
          value: combocat.items[combocat.uid],
        };
        this.touchedFields.delete(id);
      } else {
        cat[id] = {
          uid: '',
          value: '',
        };
      }
      this.updatePartNewPart({ prp_combo_categories: cat });
    },

    updatePartNewPart(data) {
      if (Object.prototype.hasOwnProperty.call(data, 'prp_combo_categories')) {
        // change data structure for backend
        for (const [key, value] of Object.entries(data['prp_combo_categories'])) {
          data['prp_combo_categories'][key] = value.uid;
        }
      }

      this.savePart(data);
    },

    async savePart(formData) {
      await this.axiosInstance
        .put(`/api/v1/prp-order/`, formData)
        .then(async () => {
          await this.fetchPrpOrderData();
        })
        .catch(error => {
          console.error(JSON.stringify(error));
        });
    },
  },
};
</script>
